import { jsxs, jsx } from 'react/jsx-runtime';
import { IconButton, useToast, useRandomAvatarColor, Tooltip, PrimitiveAnchor, stopEvent, Text, Avatar } from '@flex-design-system/fx';
import { OverflowTextTooltip, Linkify } from '@flex-design-system/fx-extension';
import { PhoneIcon, EmailIcon } from '@flex-design-system/legacy-flex-icons';
import { styled } from '@flex-design-system/stitches-react';
import { Stack, Flex } from '@flex-design-system/utils-style';
import { useTranslation } from '@flex-mf/i18n';
import { PreventFromLeavingDialog, useIsEditingAtomValue, useUserProfileHref } from '@flex-services/user-profile/components';
import { isoDatePartToDate } from '@flexteam/date';
import { useFlexRouter, Link } from '@flexteam/router';
import { copyToClipBoard, formatContactNumber } from '@flexteam/utils';
import { useCallback, useEffect } from 'react';
import '../apis/core/apis/bank-code-controller-api.mjs';
import '../apis/core/apis/business-place-controller-api.mjs';
import '../apis/core/apis/business-place-department-action-controller-api.mjs';
import '../apis/core/apis/business-place-department-controller-api.mjs';
import '../apis/core/apis/business-place-user-action-controller-api.mjs';
import '../apis/core/apis/business-place-user-controller-api.mjs';
import '../apis/core/apis/competency-api-controller-api.mjs';
import '../apis/core/apis/competency-category-api-controller-api.mjs';
import '../apis/core/apis/competency-excel-api-controller-api.mjs';
import '../apis/core/apis/competency-permission-api-controller-api.mjs';
import '../apis/core/apis/competency-search-api-controller-api.mjs';
import '../apis/core/apis/core-user-data-approval-change-api-controller-api.mjs';
import '../apis/core/apis/core-user-data-approval-step-api-controller-api.mjs';
import '../apis/core/apis/core-user-data-approval-thread-api-controller-api.mjs';
import '../apis/core/apis/customer-allowance-controller-api.mjs';
import '../apis/core/apis/customer-attachment-action-controller-api.mjs';
import '../apis/core/apis/customer-attachment-controller-api.mjs';
import '../apis/core/apis/customer-info-controller-api.mjs';
import '../apis/core/apis/customer-signature-controller-api.mjs';
import '../apis/core/apis/department-action-controller-api.mjs';
import '../apis/core/apis/department-controller-api.mjs';
import '../apis/core/apis/department-user-action-controller-api.mjs';
import '../apis/core/apis/department-user-controller-api.mjs';
import '../apis/core/apis/dependent-family-action-controller-api.mjs';
import '../apis/core/apis/dependent-family-attachment-action-controller-api.mjs';
import '../apis/core/apis/dependent-family-attachment-controller-api.mjs';
import '../apis/core/apis/dependent-family-controller-api.mjs';
import '../apis/core/apis/dependent-family-support-controller-api.mjs';
import '../apis/core/apis/discipline-api-controller-api.mjs';
import '../apis/core/apis/education-experience-action-controller-api.mjs';
import '../apis/core/apis/education-experience-controller-api.mjs';
import '../apis/core/apis/employee-record-card-api-controller-api.mjs';
import '../apis/core/apis/image-preset-api-controller-api.mjs';
import '../apis/core/apis/job-group-action-controller-api.mjs';
import '../apis/core/apis/job-group-controller-api.mjs';
import '../apis/core/apis/job-level-action-controller-api.mjs';
import '../apis/core/apis/job-level-controller-api.mjs';
import '../apis/core/apis/job-rank-action-controller-api.mjs';
import '../apis/core/apis/job-rank-controller-api.mjs';
import '../apis/core/apis/job-rank-new-action-controller-api.mjs';
import '../apis/core/apis/job-role-action-controller-api.mjs';
import '../apis/core/apis/job-role-controller-api.mjs';
import '../apis/core/apis/job-role-new-action-controller-api.mjs';
import '../apis/core/apis/job-role-user-action-controller-api.mjs';
import '../apis/core/apis/job-title-action-controller-api.mjs';
import '../apis/core/apis/job-title-controller-api.mjs';
import '../apis/core/apis/job-title-new-action-controller-api.mjs';
import '../apis/core/apis/jurisdiction-controller-api.mjs';
import '../apis/core/apis/language-controller-api.mjs';
import '../apis/core/apis/language-level-controller-api.mjs';
import '../apis/core/apis/pause-support-controller-api.mjs';
import '../apis/core/apis/personnel-appointment-action-controller-api.mjs';
import '../apis/core/apis/personnel-appointment-controller-api.mjs';
import '../apis/core/apis/personnel-appointment-detail-action-controller-api.mjs';
import '../apis/core/apis/personnel-appointment-detail-controller-api.mjs';
import '../apis/core/apis/personnel-appointment-label-api-controller-api.mjs';
import '../apis/core/apis/project-api-controller-api.mjs';
import '../apis/core/apis/signature-file-action-controller-api.mjs';
import '../apis/core/apis/skill-api-controller-api.mjs';
import '../apis/core/apis/training-api-controller-api.mjs';
import '../apis/core/apis/user-apprenticeship-contract-action-controller-api.mjs';
import '../apis/core/apis/user-apprenticeship-contract-controller-api.mjs';
import '../apis/core/apis/user-attachment-action-controller-api.mjs';
import '../apis/core/apis/user-attachment-controller-api.mjs';
import '../apis/core/apis/user-bank-account-action-controller-api.mjs';
import '../apis/core/apis/user-bank-account-controller-api.mjs';
import '../apis/core/apis/user-basic-bundle-action-controller-api.mjs';
import '../apis/core/apis/user-career-api-controller-api.mjs';
import '../apis/core/apis/user-certificate-issuance-history-action-controller-api.mjs';
import '../apis/core/apis/user-certificate-issuance-history-controller-api.mjs';
import '../apis/core/apis/user-certificate-issuance-policy-controller-api.mjs';
import '../apis/core/apis/user-contract-support-controller-api.mjs';
import '../apis/core/apis/user-controller-api.mjs';
import '../apis/core/apis/user-custom-property-action-controller-api.mjs';
import '../apis/core/apis/user-custom-property-bulk-action-controller-api.mjs';
import '../apis/core/apis/user-custom-property-category-controller-api.mjs';
import '../apis/core/apis/user-custom-property-controller-api.mjs';
import '../apis/core/apis/user-custom-property-info-action-controller-api.mjs';
import '../apis/core/apis/user-custom-property-info-controller-api.mjs';
import '../apis/core/apis/user-discipline-api-controller-api.mjs';
import '../apis/core/apis/user-document-action-controller-api.mjs';
import '../apis/core/apis/user-document-file-action-controller-api.mjs';
import '../apis/core/apis/user-document-legacy-controller-api.mjs';
import '../apis/core/apis/user-email-change-action-controller-api.mjs';
import '../apis/core/apis/user-email-controller-api.mjs';
import '../apis/core/apis/user-employee-bundle-action-controller-api.mjs';
import '../apis/core/apis/user-employee-controller-api.mjs';
import '../apis/core/apis/user-employee-support-controller-api.mjs';
import '../apis/core/apis/user-employment-contract-action-controller-api.mjs';
import '../apis/core/apis/user-employment-contract-bundle-action-controller-api.mjs';
import '../apis/core/apis/user-employment-contract-controller-api.mjs';
import '../apis/core/apis/user-info-download-action-controller-api.mjs';
import '../apis/core/apis/user-info-download-action-controller-v2-api.mjs';
import '../apis/core/apis/user-language-level-controller-api.mjs';
import '../apis/core/apis/user-leave-of-absence-action-controller-api.mjs';
import '../apis/core/apis/user-leave-of-absence-controller-api.mjs';
import '../apis/core/apis/user-license-controller-api.mjs';
import '../apis/core/apis/user-memo-action-controller-api.mjs';
import '../apis/core/apis/user-memo-controller-api.mjs';
import '../apis/core/apis/user-personal-action-controller-api.mjs';
import '../apis/core/apis/user-personal-bundle-action-controller-api.mjs';
import '../apis/core/apis/user-personal-controller-api.mjs';
import '../apis/core/apis/user-personal-support-controller-api.mjs';
import '../apis/core/apis/user-personnel-appointment-action-controller-api.mjs';
import '../apis/core/apis/user-personnel-appointment-controller-api.mjs';
import '../apis/core/apis/user-public-info-action-controller-api.mjs';
import '../apis/core/apis/user-remark-controller-api.mjs';
import '../apis/core/apis/user-resignation-action-controller-api.mjs';
import '../apis/core/apis/user-resignation-controller-api.mjs';
import '../apis/core/apis/user-restrict-info-action-controller-api.mjs';
import '../apis/core/apis/user-reward-api-controller-api.mjs';
import '../apis/core/apis/user-salary-contract-action-controller-api.mjs';
import '../apis/core/apis/user-salary-contract-controller-api.mjs';
import '../apis/core/apis/user-setting-controller-api.mjs';
import '../apis/core/apis/user-setting-custom-controller-api.mjs';
import '../apis/core/apis/user-setting-meta-controller-api.mjs';
import '../apis/core/apis/user-signature-controller-api.mjs';
import '../apis/core/apis/user-status-controller-api.mjs';
import '../apis/core/apis/user-workplace-controller-api.mjs';
import '../apis/core/apis/user-workspace-controller-api.mjs';
import '../apis/core/apis/work-experience-action-controller-api.mjs';
import '../apis/core/apis/work-experience-controller-api.mjs';
import '../apis/core/apis/workplace-controller-api.mjs';
import '../apis/core/apis/workplace-department-action-controller-api.mjs';
import '../apis/core/apis/workplace-department-controller-api.mjs';
import '../apis/core/apis/workplace-user-action-controller-api.mjs';
import '../apis/core/apis/workplace-user-controller-api.mjs';
import { PermissionStatus } from '../apis/core/models/permission-status.mjs';
import { SearchUserStatus } from '../apis/core/models/search-user-status.mjs';
import { useUpdateUserEmployeeBundlePermissionsRemote } from '../apis/core-hooks/useUpdateUserEmployeeBundlePermissionsRemote.mjs';
import getEmptyDisplayText from '../avatar/getEmptyDisplayText.mjs';
import { decideAvatarSource } from '../avatar/utils.mjs';
import useSearchUserByIdsRemote from '../packages/core-search-hooks/useSearchUserByIdsRemote.mjs';
import { formatDisplayUsername } from '../packages/core-user-base/formatDisplayUsername.mjs';
import useCurrentUser from '../packages/core-user-me-hooks/useCurrentUser.mjs';
import JobRoleExtraTag from './JobRoleExtraTag.mjs';
import PositionTag from './PositionTag.mjs';
import StatusTag from './StatusTag.mjs';

const staleTime = 5 * 60 * 1e3;
function UserMiniProfile({
  userIdHash,
  onContentLoaded,
  onNavigateToUserProfile
}) {
  const {
    data: { userIdHash: currentUserIdHash, customerIdHash }
  } = useCurrentUser({
    staleTime
  });
  const preventFromLeavingDialogRef = PreventFromLeavingDialog.useForwardedRef();
  const { queryParams, push } = useFlexRouter();
  const isInUserProfile = queryParams["user_profile_uid" /* UserIdHash */] != null;
  const isEditing = useIsEditingAtomValue();
  const needLeavingConfirm = isInUserProfile && isEditing;
  const { getUserProfileHref } = useUserProfileHref();
  const { success } = useToast();
  const { t } = useTranslation();
  const handleCopyToClipboard = useCallback(
    (type, copyContent) => {
      copyToClipBoard(copyContent).then(
        () => success(
          t("@flex-services/user-avatar.global.clipboard_copy_message", {
            message: type
          })
        )
      );
    },
    [success, t]
  );
  const { data: userSearchData = [], isLoading } = useSearchUserByIdsRemote(
    { customerIdHash, userIdHashes: [userIdHash] },
    { staleTime, suspense: false }
  );
  const isResignedUser = userSearchData[0]?.tagInfo?.userStatuses?.includes(
    SearchUserStatus.Resignation
  ) ?? false;
  const { data: hrPermission } = useUpdateUserEmployeeBundlePermissionsRemote(
    {
      userIdHash: currentUserIdHash
    },
    {
      enabled: isResignedUser,
      suspense: false
    }
  );
  const hasHrPermission = hrPermission?.POST === PermissionStatus.Granted;
  const isForbiddenLinkToUserProfile = isResignedUser && !hasHrPermission;
  const avatarBgColor = useRandomAvatarColor({
    key: userIdHash
  });
  useEffect(() => {
    if (!isLoading) {
      onContentLoaded?.();
    }
  }, [isLoading, onContentLoaded]);
  if (userSearchData.length === 0 || isLoading) {
    return null;
  }
  const { basicInfo, employeeInfo, tagInfo, privateInfo } = userSearchData[0];
  const {
    displayName,
    profileImageUrl,
    profileImageFileKey,
    name,
    companyJoinDate: rawCompanyJoinDate,
    email,
    aboutMe
  } = basicInfo ?? {};
  const { jobRoles = [], positions = [] } = employeeInfo ?? {};
  const { userStatuses = [] } = tagInfo ?? {};
  const { phoneNumber } = privateInfo ?? {};
  const emptyAvatarText = getEmptyDisplayText(displayName ?? "", email);
  const hasPhoneNumber = isValidContent(phoneNumber);
  const hasEmail = isValidContent(email);
  const avatarSource = decideAvatarSource({
    profileImageFileKey,
    profileImageUrl,
    size: "xlarge"
  });
  const companyJoinDate = rawCompanyJoinDate != null ? isoDatePartToDate(rawCompanyJoinDate) : void 0;
  const avatarContent = /* @__PURE__ */ jsxs(
    Avatar,
    {
      color: avatarBgColor,
      size: "xlarge",
      css: isForbiddenLinkToUserProfile ? {} : { clickable: "strong" },
      onPointerDown: (e) => e.preventDefault(),
      children: [
        /* @__PURE__ */ jsx(
          Avatar.Image,
          {
            src: avatarSource.src,
            srcSet: avatarSource.srcSet,
            alt: name
          }
        ),
        /* @__PURE__ */ jsx(Avatar.Fallback, { children: emptyAvatarText })
      ]
    }
  );
  const displayNameContent = formatDisplayUsername({
    name,
    nameInOffice: displayName ?? ""
  });
  return /* @__PURE__ */ jsxs(Root, { children: [
    /* @__PURE__ */ jsxs(TitleRoot, { space: 16, children: [
      /* @__PURE__ */ jsxs(AvatarRow, { justify: "space-between", children: [
        isForbiddenLinkToUserProfile ? avatarContent : needLeavingConfirm ? /* @__PURE__ */ jsxs(Tooltip, { children: [
          /* @__PURE__ */ jsx(
            Tooltip.Trigger,
            {
              asChild: true,
              onClick: () => preventFromLeavingDialogRef.current?.open(),
              children: avatarContent
            }
          ),
          /* @__PURE__ */ jsx(Tooltip.Content, { children: t(
            "@flex-services/user-avatar.domains.core-user.mini-profile.\uD504\uB85C\uD544_\uC0C1\uC138_\uBCF4\uAE30"
          ) })
        ] }) : /* @__PURE__ */ jsxs(Tooltip, { children: [
          /* @__PURE__ */ jsx(
            Link,
            {
              passHref: true,
              href: getUserProfileHref(userIdHash),
              replace: true,
              state: {
                custom: {
                  hr: employeeInfo,
                  basic: { ...basicInfo, ...privateInfo },
                  statuses: tagInfo.userStatuses
                }
              },
              shallow: false,
              children: /* @__PURE__ */ jsx(Tooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(PrimitiveAnchor, { onClick: onNavigateToUserProfile, children: avatarContent }) })
            }
          ),
          /* @__PURE__ */ jsx(Tooltip.Content, { children: t(
            "@flex-services/user-avatar.domains.core-user.mini-profile.\uD504\uB85C\uD544_\uC0C1\uC138_\uBCF4\uAE30"
          ) })
        ] }),
        /* @__PURE__ */ jsxs(Stack.Horizontal, { space: 2, children: [
          /* @__PURE__ */ jsxs(Tooltip, { children: [
            /* @__PURE__ */ jsx(Tooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(
              StyledIconButton,
              {
                variant: "ghost",
                color: "blackAlpha048",
                "aria-disabled": !hasPhoneNumber,
                onClick: (e) => {
                  stopEvent(e);
                  whenValidContent(
                    phoneNumber,
                    (_phoneNumber) => handleCopyToClipboard(
                      t("@flex-services/user-avatar.global.\uC804\uD654\uBC88\uD638"),
                      _phoneNumber
                    )
                  );
                },
                onPointerDown: (e) => e.preventDefault(),
                icon: /* @__PURE__ */ jsx(PhoneIcon, {})
              }
            ) }),
            /* @__PURE__ */ jsx(Tooltip.Content, { children: /* @__PURE__ */ jsx(Text, { color: hasPhoneNumber ? "white" : "whiteAlpha056", children: hasPhoneNumber ? formatContactNumber(phoneNumber) : t(
              "@flex-services/user-avatar.domains.core-user.\uC804\uD654\uBC88\uD638_\uC5C6\uC74C_\uBA54\uC138\uC9C0"
            ) }) })
          ] }),
          /* @__PURE__ */ jsxs(Tooltip, { children: [
            /* @__PURE__ */ jsx(Tooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(
              IconButton,
              {
                variant: "ghost",
                color: "blackAlpha048",
                "aria-disabled": !hasEmail,
                onClick: (e) => {
                  stopEvent(e);
                  whenValidContent(
                    email,
                    (_email) => handleCopyToClipboard(
                      t("@flex-services/user-avatar.global.\uC774\uBA54\uC77C_\uC8FC\uC18C"),
                      _email
                    )
                  );
                },
                onPointerDown: (e) => e.preventDefault(),
                description: void 0,
                icon: /* @__PURE__ */ jsx(EmailIcon, {})
              }
            ) }),
            /* @__PURE__ */ jsx(Tooltip.Content, { children: /* @__PURE__ */ jsx(Text, { color: hasEmail ? "white" : "whiteAlpha056", children: hasEmail ? email : t(
              "@flex-services/user-avatar.domains.core-user.\uC774\uBA54\uC77C_\uC5C6\uC74C_\uBA54\uC138\uC9C0"
            ) }) })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(TitleNameRoot, { space: 7, children: [
        /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
          userStatuses != null && /* @__PURE__ */ jsx(
            StatusTag,
            {
              userStatuses,
              companyJoinDate
            }
          ),
          isForbiddenLinkToUserProfile ? /* @__PURE__ */ jsxs(OverflowTextTooltip, { children: [
            /* @__PURE__ */ jsx(OverflowTextTooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(
              OverflowTextTooltip.Text,
              {
                color: "grayDarker",
                weight: 700,
                size: 18,
                children: displayNameContent
              }
            ) }),
            /* @__PURE__ */ jsx(OverflowTextTooltip.Content, {})
          ] }) : needLeavingConfirm ? /* @__PURE__ */ jsxs(OverflowTextTooltip, { children: [
            /* @__PURE__ */ jsx(OverflowTextTooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(
              OverflowTextTooltip.Text,
              {
                onClick: () => preventFromLeavingDialogRef.current?.open(),
                children: displayNameContent
              }
            ) }),
            /* @__PURE__ */ jsx(OverflowTextTooltip.Content, {})
          ] }) : /* @__PURE__ */ jsx(
            Link,
            {
              passHref: true,
              href: getUserProfileHref(userIdHash),
              replace: true,
              shallow: true,
              children: /* @__PURE__ */ jsx(
                PrimitiveAnchor,
                {
                  css: { display: "block" },
                  onClick: onNavigateToUserProfile,
                  children: /* @__PURE__ */ jsxs(OverflowTextTooltip, { children: [
                    /* @__PURE__ */ jsx(OverflowTextTooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(
                      OverflowTextTooltipTextLink,
                      {
                        color: "grayDarker",
                        weight: 700,
                        size: 18,
                        children: displayNameContent
                      }
                    ) }),
                    /* @__PURE__ */ jsx(OverflowTextTooltip.Content, {})
                  ] })
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ jsx(WhenHasData, { data: jobRoles, children: /* @__PURE__ */ jsxs(Stack.Horizontal, { space: 6, children: [
          /* @__PURE__ */ jsx(Text, { children: jobRoles[0]?.name }),
          /* @__PURE__ */ jsx(JobRoleExtraTag, { jobRoles })
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(WhenHasData, { data: aboutMe, children: /* @__PURE__ */ jsx(BodyRoot, { children: /* @__PURE__ */ jsx(Linkify, { children: /* @__PURE__ */ jsx(
      Text,
      {
        color: "grayDarker",
        size: 14,
        weight: 400,
        lineHeight: "paragraph",
        ellipsis: { lineClamp: 4 },
        children: aboutMe
      }
    ) }) }) }),
    /* @__PURE__ */ jsx(WhenHasData, { data: positions, children: /* @__PURE__ */ jsx(BottomRoot, { wrap: "wrap", children: positions.map((position) => {
      return /* @__PURE__ */ jsx(
        PositionTag,
        {
          position
        },
        position.departmentIdHash
      );
    }) }) }),
    /* @__PURE__ */ jsx(
      PreventFromLeavingDialog,
      {
        ref: preventFromLeavingDialogRef,
        onConfirm: () => push(getUserProfileHref(userIdHash))
      }
    )
  ] });
}
const Root = styled("div", {
  padding: 24
});
const TitleRoot = styled(Stack.Vertical, {
  paddingBottom: 8
});
const AvatarRow = styled(Stack.Horizontal, {
  width: "100%"
});
const TitleNameRoot = styled(Stack.Vertical, {
  paddingLeft: 1
});
const OverflowTextTooltipTextLink = styled(OverflowTextTooltip.Text, {
  "&:active": {
    opacity: 0.7
  }
});
const BodyRoot = styled("div", {
  py: 4,
  paddingLeft: 1,
  lineHeight: 1.6
});
const BottomRoot = styled(Flex.Row, {
  paddingTop: 12,
  gap: 5
});
const StyledIconButton = styled(IconButton, {
  '&[aria-disabled="true"]': {
    cursor: "not-allowed",
    opacity: 0.6
  }
});
function WhenHasData(props) {
  const { children, data, fallback = null } = props;
  if (data == null || Array.isArray(data) && data.length === 0 || typeof data === "string" && data === "") {
    return fallback;
  }
  return children;
}
function isValidContent(content) {
  return content != null && content !== "";
}
function whenValidContent(content, player) {
  if (content == null || content === "") {
    return;
  }
  player(content);
}

export { UserMiniProfile as default };
//# sourceMappingURL=Content.mjs.map
